export default __webpack_public_path__ + "static-json/ne_110m_populated_places-32d38367212a775f187ac89706c2ad84.json";